import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: start;

  ${screen.md} {
    grid-template-columns: minmax(0, 1fr) minmax(240px, 380px);
    gap: 24px;
  }

  ${screen.lg} {
    grid-template-columns: minmax(0, 1fr) 480px;
    gap: 32px;
  }

  ${screen.xxlg} {
    gap: 40px;
  }
`;

export const StepsHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const StepsTitle = styled.h3`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 28px;
  margin: 0;
  color: ${homeColor.white};

  ${screen.lg} {
    font-size: 34px;
  }

  ${screen.xxlg} {
    font-size: 38px;
  }
`;

export const StepsList = styled.div`
  border-top: 1px solid ${homeColor.carbon};
`;

export const StepRow = styled.div`
  display: flex;
  gap: 18px;
  align-items: flex-start;
  padding: 20px 0;
  border-bottom: 1px solid ${homeColor.carbon};
`;

export const StepNumber = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  font-size: 11px;
  color: ${homeColor.green};
  margin: 0;
  flex: none;
  width: 24px;
`;

export const StepCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: 0;
`;

export const StepTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 16px;
  color: ${homeColor.white};
  margin: 0;

  ${screen.lg} {
    font-size: 17px;
  }
`;

export const StepDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.55;
  color: ${homeColor.muted};
  margin: 0;

  ${screen.lg} {
    font-size: 15px;
  }
`;

export const OutcomesCard = styled.div`
  border: 1px solid ${homeColor.cyan};
  border-radius: 16px;
  padding: 24px;
  background: linear-gradient(
    90deg,
    rgba(0, 215, 215, 0.1) 0%,
    rgba(20, 213, 77, 0.1) 55%,
    rgba(132, 241, 30, 0.1) 100%
  );
  box-shadow: 0 0 15px 0 rgba(20, 214, 77, 0.35);

  ${screen.lg} {
    padding: 40px;
  }
`;

export const OutcomesHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
`;

export const OutcomesTitle = styled.h3`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-size: 22px;
  color: ${homeColor.green};
  margin: 0;

  ${screen.lg} {
    font-size: 26px;
  }
`;

export const OutcomesList = styled.div``;

export const OutcomeRow = styled.div`
  padding: 20px 0;

  &:not(:first-child) {
    border-top: 1px solid rgba(20, 214, 77, 0.16);
  }
`;

export const OutcomeTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 18px;
  color: ${homeColor.green};
  margin: 0 0 6px;
`;

export const OutcomeDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.55;
  color: ${homeColor.white};
  margin: 0;
`;
